import { formatNaira } from "@/utils/currencyUtils";

interface NotificationMessageProps {
  message: string;
}

export function NotificationMessage({ message }: NotificationMessageProps) {
  // Check if this is a notification that might have formatting issues
  const formatNotificationMessage = (msg: string) => {
    // Pattern to match cashout messages with amounts that might be incorrectly formatted
    const cashoutPattern = /Your cashout request for ₦([\d,.]+)/;
    // Pattern to match verification payment messages
    const verificationPattern =
      /verification confirmation email sent successfully|Your profile has been verified|verification for ₦([\d,.]+)|amount_paid.*₦([\d,.]+)/;
    const match = msg.match(cashoutPattern);

    if (match) {
      const amountStr = match[1];
      // Remove any commas and parse as number
      const amount = parseFloat(amountStr.replace(/,/g, ""));

      // Check if the amount looks like it was incorrectly converted (less than 10)
      // If so, multiply by 100 to get the correct naira amount
      const correctedAmount = amount < 10 ? amount * 100 : amount;

      // Format the corrected amount properly
      const formattedAmount = formatNaira(correctedAmount);
      return msg.replace(/₦[\d,.]+/, formattedAmount);
    }

    // Handle verification payment messages that might show ₦24.00 instead of ₦24,000
    if (verificationPattern.test(msg)) {
      // Replace any occurrence of ₦24.00 with ₦24,000.00 in verification contexts
      return msg.replace(/₦24\.00/g, "₦24,000.00");
    }

    return msg;
  };

  const formattedMessage = formatNotificationMessage(message);

  return (
    <p className="text-sm text-muted-foreground line-clamp-2">
      {formattedMessage}
    </p>
  );
}
